import { message } from 'antd'
import classNames from 'classnames'
import React, { useState, forwardRef, useRef, useImperativeHandle, } from 'react'
import moment from 'moment'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'
import TextArea from 'meinian-package/src/baseComponent/textarea'
import './index.less'

export default function Comment(props) {
  const { className, style, data = {}, onReply, onDelete, hiddenReply, hiddenDelete } = props
  const { content, createdAt, responseUserId, responseUserName, userName, userAvatar, commentDesc } = data || {}
  return <div className={classNames('meinian-comment-wrap', className)} style={style} data-id={data.id}>
    <div className={classNames('meinian-comment', className)}>
      <img className="avatar" src={userAvatar || 'https://zhiyi-web.oss-cn-hangzhou.aliyuncs.com/deepfashion/default-avatar.png'} />
      <div className="wrap">
        <div className="name">
          <div className="text-overflow" style={{ maxWidth: '156px' }}>{userName}</div>
          {commentDesc && <span style={{ color: '#E34D59' }}>{commentDesc}</span>}
          {responseUserId ? <span className="name-reply">回复&nbsp;&nbsp;<div className="reply-user-name text-overflow">{responseUserName}</div></span> : ''}
        </div>
        <div style={{ flex: 1 }}>
          <div className="content">{content}</div>
        </div>
        <div className="footer-wrap">
          <span className="date">{moment(createdAt).format('YYYY-MM-DD HH:mm')}</span>
          <span>
            {hiddenDelete ? null : <span className="delete" onClick={() => onDelete && onDelete(data)}>删除</span>}
            {hiddenReply ? null : <span className="reply" onClick={() => onReply && onReply(data)}>回复</span>}
          </span>
        </div>
      </div>
    </div>
  </div>
}
const MAX_LENGTH = 150
export const CreateComment = forwardRef((props, ref) => {
  const {
    blogId,
    responseId,
    responseUserId,
    responseUserName,
    successMessage,
    className,
    onChange,
    onInput,
    placeholder,
    type,
    collectOrSampleId
  } = props
  const [value, setValue] = useState('')
  const $div = useRef()

  useImperativeHandle(ref, () => ({
    clear: onClear,
    focus: () => $div.current.$textarea.focus(),
    create: () => create($div.current?.$textarea.value)
  }))

  const onClear = () => {
    setValue('')
  }

  const create = async (comment) => {
    await request.post('/zhikuan/ins/inspiration/add-user-comment', {
      blogId,
      collectOrSampleId,
      content: comment,
      responseId,
      responseUserId,
      type
    })
    setValue('')
    message.success(successMessage || '发表成功')
    onChange && onChange()
  }

  const onKeyDown = (e) => {
    e.stopPropagation()
    if (e.keyCode === 13) {
      if (!e.target.value.trim()) {
        message.error('请输入评论内容')
        return
      }
      create(e.target.value)
    }
  }
  const _onInput = (e) => {
    setValue(e.target.value)
    onInput?.(e.target.value)
  }
  const _placeholder = placeholder || '发表评论，按「ENTER」键或发布按钮发送'

  return <TextArea
    ref={$div}
    value={value}
    maxHeight={236}
    minHeight="24"
    style={{ height: '24px' }}
    wrapClassName={classNames('meinian-create-comment', className)}
    prefix={responseId && <div className="prefix">回复@{responseUserName}:</div>}
    suffix={<div className="suffix">{`${value.length || 0}/${MAX_LENGTH}`}</div>}
    maxLength={MAX_LENGTH}
    onKeyDown={onKeyDown}
    onInput={_onInput}
    placeholder={responseId ? '' : _placeholder}
  />
})

export const DeleteComment = (props) => {
  const { onChange, comment = {}, blogId, type } = props
  ModalConfirm.show({
    title: '提示',
    content: '确定删除该条评论吗？',
    onOk: async () => {
      try {
        await request.get('/zhikuan/ins/inspiration/delete-user-comment', { params: { blogId, id: comment.id, type } })
        onChange && onChange()
        message.success('已删除')
      } catch (err) {
        console.error(err)
      }
    }
  })
}
